import { Card } from '@mui/material';
import PropTypes from 'prop-types';

export default function SimpleCard({ children, ...rest }) {
  return (
    <Card {...rest} style={{ borderRadius: '20px', padding: '15px', marginTop: '10px' }}>
      {children}
    </Card>
  );
}

SimpleCard.propTypes = {
  children: PropTypes.node.isRequired,
};
